module.exports = __webpack_public_path__ + "img/extended.d43696a5.png";